<template>
  <div>
    <back />
    <div class="det">
      <div class="top">
        <div class="title">订单信息：</div>
        <el-form :model="ruleForm" ref="ruleForm" label-width="100px" class="demo-ruleForm">
          <el-row>
            <div style="display: flex;justify-content: space-between;">
              <el-col :span="5">
                <el-form-item label="门店名称:">
                  <div> {{ ruleForm.storeName }}</div>
                </el-form-item>
              </el-col>
              <el-col :span="5">
                <el-form-item label="订单编号:">
                  <div> {{ ruleForm.orderCode }}</div>
                </el-form-item>
              </el-col>
              <el-col :span="5">
                <el-form-item label="订单类型:">
                  <div>配送</div>
                </el-form-item>
              </el-col>
              <el-col :span="5">
                <el-form-item label="订单状态:">
                  <div v-if="ruleForm.orderStatus == -1">已取消</div>
                  <div v-if="ruleForm.orderStatus == 0" style="color: red;">待支付</div>
                  <div v-if="ruleForm.orderStatus == 1" style="color: red;">待发货</div>
                  <div v-if="ruleForm.orderStatus == 2">已发货</div>
                  <!-- <div v-if="ruleForm.orderStatus == 3" style="color: red;">待自提</div> -->
                  <div v-if="ruleForm.orderStatus == 4">已完成</div>
                  <div v-if="ruleForm.orderStatus == 5">已取消</div>
                </el-form-item>
              </el-col>
            </div>
          </el-row>
          <el-row>
            <div style="display: flex;justify-content: space-between;">
              <el-col :span="5">
                <el-form-item label="售后状态:">
                  <div v-if="ruleForm.aftersaleStatus == 1" style="color: red;">售后中</div>
                  <div v-if="ruleForm.aftersaleStatus == 2">售后成功</div>
                  <div v-if="ruleForm.aftersaleStatus == 3">售后关闭</div>
                  <div v-if="ruleForm.aftersaleStatus == 0">--</div>
                </el-form-item>
              </el-col>
              <el-col :span="5">
                <el-form-item label="订单金额:">
                  <div>{{ ruleForm.orderAmount }} 元</div>
                </el-form-item>
              </el-col>
              <el-col :span="5">

                <el-form-item label="优惠金额:">
                  <div>{{ ruleForm.discountAmount }} 元</div>
                </el-form-item>
              </el-col>
              <el-col :span="5">
                <!-- <el-form-item label="打包费用:">
                  <div>{{ ruleForm.packAmount }} 元</div>
                </el-form-item> -->
                <el-form-item label="运费金额:">
                  <!-- <div>{{ ruleForm.freight }} 元</div> -->
                  <div>{{ ruleForm.freightAmount }} 元</div>
                </el-form-item>
              </el-col>
            </div>
          </el-row>
          <el-row>
            <div style="display: flex;justify-content: space-between;">
              <el-col :span="5">
                <el-form-item label="下单时间:">
                  <div>{{ ruleForm.orderTime }}</div>
                </el-form-item>
              </el-col>
              <el-col :span="5">
                <el-form-item label="付款时间:">
                  <div>{{ ruleForm.paymentTime || '--' }}</div>
                </el-form-item>
              </el-col>
              <el-col :span="5">
                <el-form-item label="完成时间:" v-if="ruleForm.orderStatus == 4">
                  <div>{{ ruleForm.completionTime }}</div>
                </el-form-item>
                <el-form-item label="取消时间:" v-if="ruleForm.orderStatus == 5">
                  <div>{{ ruleForm.cancelTime }}</div>
                </el-form-item>
              </el-col>
              <el-col :span="5">
                <el-form-item label="申请售后时间:" v-if="ruleForm.aftersaleStatus >= 1">
                  <div>{{ ruleForm.afterSalesTime }}</div>
                </el-form-item>
              </el-col>
            </div>
          </el-row>
          <el-row v-if="ruleForm.aftersaleStatus >= 1">
            <el-col>
              <el-form-item label="售后处理时间:" v-if="ruleForm.aftersaleStatus == 2">
                <div>{{ ruleForm.completionAfterSalesTime }}</div>
              </el-form-item>
              <el-form-item label="取消售后时间:" v-if="ruleForm.aftersaleStatus == 3">
                <div>{{ ruleForm.cancelAfterSalesTime }}</div>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col>
              <el-form-item label="备注：" label-width="85px">
                <div>{{ ruleForm.buyerNotes || '--' }}</div>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <!-- 用户信息 -->
      <div class="top">
        <div class="title">用户信息：</div>
        <el-form :model="ruleForm" ref="ruleForm" label-width="100px" class="demo-ruleForm">
          <el-row>
            <div style="display: flex;justify-content: space-between;">
              <el-col :span="5">
                <el-form-item label="用户编号：">
                  <div>{{ ruleForm.userCode || '--' }}</div>
                </el-form-item>
              </el-col>
              <el-col :span="5">
                <el-form-item label="用户昵称：">
                  <div>{{ ruleForm.userName || '--' }}</div>
                </el-form-item>
              </el-col>
              <el-col :span="5">
              </el-col>
              <el-col :span="5">
              </el-col>
            </div>
          </el-row>
        </el-form>
      </div>
      <!-- 收货信息 -->
      <div class="top">
        <div class="title">收货信息：</div>
        <el-form :model="ruleForm" ref="classRuleForm" label-width="100px" class="demo-ruleForm">
          <el-row>
            <div style="display: flex;justify-content: space-between;">
              <el-col :span="5">
                <el-form-item label="收货人姓名：">
                  <div>{{ ruleForm.consigneeName }}</div>
                </el-form-item>
              </el-col>
              <el-col :span="5">
                <el-form-item label="收货人电话：">
                  <div>{{ ruleForm.contactPhone }}</div>
                </el-form-item>
              </el-col>
              <el-col :span="10">
                <el-form-item label="收货人地址：">
                  <div>{{ ruleForm.address }}</div>
                </el-form-item>
              </el-col>
            </div>
          </el-row>
        </el-form>
      </div>
      <!-- 物流信息 -->
      <div class="top" v-if="ruleForm.orderStatus >= 2 && ruleForm.orderStatus <= 4">
        <div class="title">物流信息：</div>
        <el-form :model="ruleForm" ref="classRuleForm" label-width="100px" class="demo-ruleForm">
          <el-row>
            <div style="display: flex;justify-content: space-between;">
              <el-col :span="5">
                <el-form-item label="物流公司：">
                  <div>{{ ruleForm.logisticsCompany }}</div>
                </el-form-item>
                <el-form-item label="快递单号：">
                  <div>{{ ruleForm.logisticsNo }}</div>
                </el-form-item>
                <el-form-item label="发货时间：">
                  <div>{{ ruleForm.deliveryTime }}</div>
                </el-form-item>
              </el-col>
              <el-col :span="17">
                <el-form-item label="物流动态："></el-form-item>
                <div style="max-height: 250px;width: 80%;overflow: auto;padding-left: 20px;">
                  <el-timeline>
                    <el-timeline-item v-for="(item, index) in activities" :key="index" :icon="item.icon"
                      :type="item.type">
                      <h4 :style="{ color: index == 0 ? '#0096FF' : '' }">{{ `${item.status} ${item.time}` }}</h4>
                      <p>{{ item.content }}</p>
                    </el-timeline-item>
                  </el-timeline>
                </div>

              </el-col>
            </div>
          </el-row>
        </el-form>
      </div>
      <!-- 商品信息 -->
      <div class="top">
        <h4 class="title">商品信息：</h4>
        <!-- 表格 -->
        <div class="g_table tableBox">
          <el-table :data="tableData">
            <el-table-column label="序号" min-width="60" align="center">
              <template slot-scope="scope">
                {{ scope.$index + 1 }}
              </template>
            </el-table-column>
            <el-table-column prop="picUrl" label="商品图片" show-overflow-tooltip min-width="100" align="center">
              <template slot-scope="scope">
                <el-image v-show="false" :preview-src-list="srcList" ref="previewImg"></el-image>
                <div style="color: #069BBC;cursor: pointer;" @click="handleCommand(scope.row.picUrl)">查看图片</div>
              </template>
            </el-table-column>
            <el-table-column prop="barCode" label="商品条形码" show-overflow-tooltip min-width="150" align="center">
            </el-table-column>
            <el-table-column prop="productName" label="商品名称" show-overflow-tooltip min-width="150" align="center">
            </el-table-column>
            <el-table-column prop="specs" label="商品规格" show-overflow-tooltip min-width="100" align="center">
            </el-table-column>
            <el-table-column prop="categoryName" label="商品类目" show-overflow-tooltip min-width="120" align="center">
            </el-table-column>
            <el-table-column prop="brand" label="商品品牌" show-overflow-tooltip min-width="120" align="center">
            </el-table-column>
            <el-table-column prop="productPrice" label="售价(元)" show-overflow-tooltip min-width="110" align="center">
            </el-table-column>
            <el-table-column prop="productCount" label="购买数量" show-overflow-tooltip min-width="100" align="center"
              fixed="right">
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div class="bottom">
        <div>商品总价：￥{{ Number(ruleForm.productTotal).toFixed(2) }}</div>
        <div>运费：￥{{ Number(ruleForm.freightAmount).toFixed(2) }}</div>
        <!-- <div>打包费：￥{{ Number(ruleForm.packAmount).toFixed(2) }}</div> -->
        <div>优惠：￥{{ Number(ruleForm.discountAmount).toFixed(2) }}</div>
        <div>应付：<span style="color: red;font-weight: bolder;font-size: 20px;">
            ￥{{ Number(ruleForm.payAmount).toFixed(2) }}
          </span>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
export default {
  data() {
    return {
      ruleForm: {},//订单信息
      tableData: [],//服务内容
      srcList: null, //大图预览
      // 物流信息
      activities: [{
        content: '【广州市】您的快件已签收，签收人:东晓花苑，如有疑问请电联快递员:吴富冠(19880917071)，投诉电话:18620499206',
        time: '2018-04-12 20:46',
        status: '已签收',
        type: 'primary',//0
        icon: 'el-icon-more'//0
      }, {
        content: '【广州市】广东广州海珠区海联公司[13061747362]快递员吴富冠(19880917071)正在为您派件【95121为韵达快递员外呼变属号码，请放心接听】',
        time: '2018-04-12 20:46',
        status: '派件中',
      }, {
        content: '【广州市】已到达 广东广州海珠区海联公司[020-23399678]',
        time: '2018-04-12 20:46',
        status: '运输中',
      },]
    };
  },
  created() {
    this.getRequest()
  },
  methods: {
    // 修改请求当前信息
    getRequest() {
      this.loading = true;
      this.$axios.get(this.$api.productOrderInfo, {
        params: {
          orderId: this.$route.query.orderId,//订单id
        }
      }).then((res) => {
        const { code, result } = res
        if (code == 100) {
          this.ruleForm = result//订单信息
          this.tableData = result.selectOnlineOrdersProductVoList || []//服务内容
        }
      }).catch(() => {
        this.loading = false;
      })

    },
    handleCommand(imageUrl) {
      this.srcList = null
      if (imageUrl) {
        this.srcList = imageUrl;
        this.$refs.previewImg.showViewer = true;
      } else {
        this.$message.error("未上传发商品图片!");
      }
    }
  }
}
</script>

<style scoped lang='scss'>
.det {
  padding: 10px 0 0 10px;

  .title {
    font-family: Microsoft YaHei, Microsoft YaHei;
    font-weight: bold;
    font-size: 18px;
    color: #1A1A1A;
    text-align: left;
    margin-bottom: 20px;
  }

  .top {
    border-bottom: 1px solid #E2E2E2;
    margin-bottom: 30px;
    padding-bottom: 20px;

    .el-form-item {
      margin-bottom: 0px;
    }



  }

  .bottom {
    display: flex;
    align-items: flex-end;
    color: #505554;
    font-weight: bold;
    justify-content: flex-end;
    padding: 10px 0;

    div {
      margin-right: 20px;
    }
  }

}
</style>